<template>
    <Modal ref="modal" modalClass="modal-lg">
        <template #title>
            <h5 class="modal-title" id="exampleModalLabel">{{ i18n('Activate Two-Factor Auth') }}</h5>
        </template>
        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>
        <div class="row">
            <div class="col-12 text-center mb-3">
                <img :src="user.avatar_url" alt="" width="100" height="100" class="rounded-circle mb-2">
                <h5 class="mb-0">{{ user.first_name }} {{ user.last_name }}</h5>
                <p>{{ formData.message }}</p>
            </div>
            <div class="col-12 text-center mb-3">
                <img :src="formData.qr_code" alt="" width="200" height="200" class="mb-2">
            </div>
            <div class="col-12 text-center mb-3">
                <p class="mb-0">{{ i18n('Or enter the code below:') }}</p>
                <h5>{{ formData.secret_key }}</h5>
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="button" @click="submit" class="btn btn-primary text-white">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>

import api from "@/api.js";
import Modal from "@/components/common/layout/Modal.vue";
import { errorMessages } from "vue/compiler-sfc";

export default {
    components: {
        Modal,
    },
    data() {
        return {
            formData: {},
        };
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        submitted: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: null,
        },
    },
    emits: [
        'shown',
        'hidden',
        'reload',
    ],
    methods: {
        show() {
            api.post('me/2fa/enable/').then((response) => {
                this.formData.message = response.message;
                this.formData.qr_code = response.qr;
                this.formData.secret_key = response.secret;
                this.$refs['modal'].show();
            }).catch((error) => {
                console.error(error);
            });
        },
        hide() {
            this.$refs['modal'].hide();
        },
        submit() {
            let formData = { 'is_2fa_enabled': 1 };
            api.put('users/' + this.user.id, formData).then((response) => {
                this.$emit('reload');
                this.hide();
            }).catch((error) => {
                if (error.response && error.response.formData && error.response.formData.message) {
                    this.errorMessage = error.response.formData.message;
                } else {
                    this.errorMessage = errorMessages.default;
                }
            });
        },
    },
}
</script>
